import { createContext, useContext, useEffect, useState } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar-collapsed');
    return saved ? JSON.parse(saved) : false;
  });

  // Update HTML attribute whenever collapsed state changes
  useEffect(() => {
    const html = document.documentElement;
    if (isCollapsed) {
      html.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      html.setAttribute('data-sidebar-size', 'sm-hover-active');
    }
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => {
      const updated = !prev;
      localStorage.setItem('sidebar-collapsed', JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);